import React from 'react'
import VerifyAgentTable from './VerifyAgentTable'

const VerifyAgent = () => {
  return (
    <div>
      <VerifyAgentTable />
    </div>
  )
}

export default VerifyAgent